// src/api/api.js
import axios from 'axios'

// Create axios instance
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Request interceptor - adds auth token to requests
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        
        // Log all API requests to see what's being sent
        if (config.url.includes('/talents')) {
            // Ensure params object exists
            if (!config.params) {
                config.params = {};
            }
            
            // Force the limit parameter to be included
            if (config.url === '/talents' || config.url.startsWith('/talents?')) {
                // If limit is not set, set it to a default value
                if (!config.params.limit) {
                    console.warn('Limit parameter missing in talents API call, setting default');
                    config.params.limit = localStorage.getItem('paginationLimit') || 50;
                } else {
                    // Store the current limit for future use
                    localStorage.setItem('paginationLimit', config.params.limit);
                }
            }
            
        }
        
        return config
    },
    error => Promise.reject(error)
)

// Response interceptor - handles common errors
api.interceptors.response.use(
    response => response,
    error => {
        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401) {
            // We need to avoid direct store import to prevent circular dependency
            // So we'll use the window event for authentication errors
            window.dispatchEvent(new CustomEvent('auth:unauthorized'))
        }
        return Promise.reject(error)
    }
)

export default api
